// extracted by mini-css-extract-plugin
export default {"container":"Table_container__ZwWVh","scrollBox":"Table_scrollBox__hWxlv"};